import React, { useEffect } from 'react'
import { Modal, Form, Input, message } from 'antd'

import encrypt from '@pages/login/utils/encrypt'
import { modifyPwd } from '../service'

export default function EditPword(props) {
  const [form] = Form.useForm()
  const { editVisible, setEditVisible, userInfo } = props

  useEffect(() => {
    form.setFieldsValue({
      newPas: null,
      pas: null,
    })
  })

  const handleOk = () => {
    form.validateFields().then(async (values) => {
      const params = {
        newPas: encrypt(values.newPas),
        pas: encrypt(values.pas)
      }
      const res = await modifyPwd({ ...params, userId: userInfo.userId })
      if (res?._failure) {
        setEditVisible(false)
        return
      }
      message.success('修改密码成功')
      setEditVisible(false)
    })
  }

  const handleCancel = () => {
    setEditVisible(false)
  }

  const validatePwd = (rule, value, callback) => {
    if (!value) {
      callback()
      return
    }
    // 密码规则：8-16位，包含数字和英文
    const PWORD_REGEXP = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#$%^&*()_+-=[\],:;{}<>?]{8,20})$/
    if (PWORD_REGEXP.test(value)) {
      callback()
      return
    }
    callback([new Error('请输入8-20位，包含字母和数字')])
  }

  return (
    <Modal
      title="密码修改"
      visible={editVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="确定"
      cancelText="取消"
    >
      <Form
        form={form}
        name="passwordEdit"
        labelCol={{ span: 4 }} 
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          label="旧密码"
          name="pas"
          required
          rules={[{ required: true, message: '请输入旧密码' }]}
        >
          <Input.Password placeholder="请输入旧密码" />
        </Form.Item>
        <Form.Item
          label="新密码"
          name="newPas"
          required
          rules={[
            { required: true, message: '请输入新密码' },
            { validator: validatePwd }
          ]}
        >
          <Input.Password maxLength={20} placeholder="请输入8-20位，包含字母和数字" />
        </Form.Item>
      </Form>
    </Modal>
  )
} 

